export enum InvoiceStatus {
  PAID = 'LIQUIDADO',
  REFINANCED = 'REFINANCIADO',
  SUED_DELAY = 'PROCESSADO POR ATRASO',
  TOTAL_PAID = 'PAGAMENTO TOTAL EFEUADO',
  MININUM_PAID = 'PAGAMENTO MINIMO EFETUADO',
  LATE = 'EM ATRASO',
  CLOSED_TO_PAY = 'FECHADO A PAGAR',
  WAITING = 'AGUARDANDO FECHAMENTO',
  FUTURE = 'EXTRATO FUTURO',
}

export enum InvoiceSituations {
  NEXT = 'FUTURA',
  CURRENT = 'ATUAL',
  PREVIOUS = 'PASSADA',
}

export enum TransactionType {
  CREDIT = 'C',
  DEBIT = 'D',
}

export interface StatementTypeDto {
  idExtrato: number;
  numeroExtrato: string;
  saldoAnterior: number;
  saldoAtual: number;
  status: InvoiceStatus;
  totalCredito: number;
  valorFatura: number;
  valorMinimo: number;
  vencimento: string;
  situacao: InvoiceSituations;
  isPossuiBoleto: boolean;
  fechamento: string;
}

export type InvoiceDetailsDTO = {
  contrato: number;
  descricao: string;
  idExtrato: number;
  parcela: string;
  planoJuros: boolean;
  tipoTransacao: TransactionType;
  transacao: string;
  ultimaGratis: boolean;
  valorCredito: number;
  valorDebito: number;
};
